import { Helpers } from '../../helpers';
import { IForecastDurationOuomType } from '../../interfaces/iforecast-duration-ouom-type';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastDurationOuomTypeBase {
  ForecastDurationOuomTypeId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  ForecastParameterDetails_ForecastDurationOuomType?: Array<ForecastParameterDetail> | null;
  TypeCurveParameters_ForecastDurationOuomType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastDurationOuomType) {
    if (item) {

      this.ForecastDurationOuomTypeId = item.ForecastDurationOuomTypeId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.ForecastParameterDetails_ForecastDurationOuomType = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastDurationOuomType);
      this.TypeCurveParameters_ForecastDurationOuomType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastDurationOuomType);
    }
  }
}